
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M502.5 124.1c-6.9-7.1-18.2-7.1-25.1 0L256.2 349.9 34.7 124.1c-6.9-7.1-18.2-7.1-25.1 0-6.9 7.1-6.9 18.6 0 25.6L243.3 388c3.5 3.5 7.8 5.3 12.6 5.3 4.3 0 9.1-1.8 12.6-5.3L502 149.7c7.4-7.1 7.4-18.6.5-25.6z"}})])
          )
        }
      }
    